(function() {
	  'use strict';
	
	  const STATION_DATA_ENDPOINT = window.power_module.site_url + '/' + window.power_module.endpoint;
	  const STATION_DATA_ENDPOINT_POLL_INTERVAL = 90000;
	
	  var updatePowergrid = function(event, message) {
		jQuery('.js-power-grid-label').removeClass('is-hidden');
		jQuery('.js-power-grid-info').text(message);
	  }
	  jQuery(document).on('drax-powergrid', updatePowergrid);
	
	  var disablePowergrid = function(event) {
		jQuery('.js-power-grid-label').addClass('is-hidden');
		jQuery('.js-power-grid-info').text('');
	  }
	  jQuery(document).on('disable-drax-powergrid', disablePowergrid);
	
	  var getPowerGridInfo = function() {
		jQuery.ajax({
		  url: STATION_DATA_ENDPOINT,
		  dataType: 'json',
		  success : function(response) {
			var responseJSON = JSON.parse(response);
			var unitData = responseJSON['UnitData'];
			var stationOutput = 0;
			for (var i = unitData.length - 1; i >= 0; i--) {
			  stationOutput += unitData[i]['MW'];
			}
	
			var ukDemand = responseJSON['UkDemand'];
			var message = parseInt(stationOutput).toLocaleString() + ' MW | ' + ukDemand + '% of GB Grid Demand';
	
			jQuery(document).trigger('drax-powergrid', [message]);
		  },
		  error : function(response) {
			jQuery(document).trigger('disable-drax-powergrid');
		  }
		});
	  }
	
	  var bindUpdatePowerGrid = function() {
		if(jQuery('.js-power-grid-info').length) {
		  getPowerGridInfo();
		  setInterval(function() {
			getPowerGridInfo();
		  }, STATION_DATA_ENDPOINT_POLL_INTERVAL);
		}
	  }
	
	  bindUpdatePowerGrid();
	})();
	